import { z } from "zod";

const irMobileRegex = /^09\d{9}$/;

export const profileAccountSchema = z.object({
  full_name: z.string().min(1, { error: "نام و نام خانوادگی الزامی است" }),
  username: z.string().min(1, { error: "نام کاربری الزامی است" }),
  phone: z
    .string()
    .min(1, { error: "شماره موبایل الزامی است" })
    .regex(irMobileRegex, { error: "شماره موبایل باید با 09 شروع و ۱۱ رقم باشد" }),
});

export type ProfileAccountFormValues = z.infer<typeof profileAccountSchema>;

const passwordFieldsSchema = z.object({
  current_password: z.string().min(1, { error: "رمز عبور فعلی الزامی است" }),
  new_password: z.string().min(8, { error: "رمز عبور جدید باید حداقل ۸ کاراکتر باشد" }),
  confirm_password: z.string().min(1, { error: "تکرار رمز عبور الزامی است" }),
});

export const profilePasswordSchema = passwordFieldsSchema.refine(
  (data) => data.new_password === data.confirm_password,
  { message: "رمز عبور و تکرار آن یکسان نیستند", path: ["confirm_password"] },
);

export type ProfilePasswordFormValues = z.infer<typeof profilePasswordSchema>;
